import { GoogleAnalyticsDataLayerParameters, GoogleAnalyticsQuoteBase, GoogleAnalyticsStudentDetails } from '@lx/shared/google-analytics';

/**
 * Quote details specific to Online Quote Tool.
 * Follows the same structure as QT Lite for consistency in dataLayer.
 */
export interface GoogleAnalyticsOnlineQuoteToolQuote extends GoogleAnalyticsQuoteBase {
  /**
   * The number of quotes requested.
   * Increments when users start a new quote.
   */
  quote?: number;

  /**
   * Class time preference for online courses.
   */
  quote_class_time?: string;

  /**
   * Timezone for online courses.
   */
  quote_time_zone?: string;
}

/**
 * Type definition for Google Analytics dataLayer parameters in Online Quote Tool.
 * Contains all the fields that will be sent to Google Analytics.
 */
export interface GoogleAnalyticsParametersType extends GoogleAnalyticsDataLayerParameters, GoogleAnalyticsStudentDetails {
  /**
   * Array of quote details. Keeps up to last 3 quotes.
   */
  quotes?: GoogleAnalyticsOnlineQuoteToolQuote[];

  /**
   * Current step identifier for analytics tracking
   */
  step?: string;

  /**
   * Type of deeplink used to access the tool (if applicable)
   */
  deeplink_type?: string;
}
